export default "__VITE_ASSET__fb31daa0__"